import { instance } from '../../../../../../services/api';
import { ICreateContactAtLocalGroupCommand } from '../../types';

// EU1832 - TO - 08/09/2022
export default (command: ICreateContactAtLocalGroupCommand) => {
    return instance.post('api/contactAtLocalGroupLinks/create', command);
};
